import {
  MainLayout as CoreMainLayout,
  IMainLayoutProps,
} from '@myhrbox/myhrbox-frontend-core';
import useMe from 'store/user/useMe';
import { useLocation } from 'react-router-dom';
import ROUTES, { RoutesValues } from 'constants/routes';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useNavigateWithReplace from 'hooks/useNavigateReplace';
import { $isPublicExamination } from 'store/assessment/model';
import { useUnit } from 'effector-react';
import withErrorBoundary from 'hocs/withErrorBoundary';
import Header from './components/Header';

const MainLayout = (props: IMainLayoutProps) => {
  const { navigate } = useNavigateWithReplace();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { children, onLogoClick, ...rest } = props;
  const { me, loading: meLoading } = useMe();
  const isPublicExamination = useUnit($isPublicExamination);

  const pathname = location.pathname as RoutesValues;

  useEffect(() => {
    if (me) {
      if (me.language && i18n.language !== me.language) {
        i18n.changeLanguage(me.language);
      }

      if (!isPublicExamination) {
        if (!me.language) {
          navigate(ROUTES.LANGUAGE_SELECT);
        } else if ((!me.phoneNumber && !me.candidateUsername.login) || !me.agreement) {
          navigate(ROUTES.CONFIRM_USER_DATA);
        } else if (
          pathname.includes(ROUTES.LANGUAGE_SELECT) ||
          pathname.includes(ROUTES.CONFIRM_USER_DATA) ||
          pathname.includes(ROUTES.LOGIN)
        ) {
          navigate(ROUTES.ASSESSMENT);
        }
      }
    }
  }, [me, pathname]);

  return (
    <CoreMainLayout
      onLogoClick={() => navigate(ROUTES.ASSESSMENT)}
      HeaderComponent={me ? <Header me={me} meLoading={meLoading} /> : undefined}
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </CoreMainLayout>
  );
};

export default withErrorBoundary(MainLayout);
